import React from 'react';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import { ThemeProvider as DSThemeProvider, orderly } from '@ptml/design-system';
import { ORDERLY_THEME } from './themes';
import type { Theme } from './themes.types';

declare module 'styled-components' {
    // Module augmentation requires an interface here; a type alias breaks declaration merging.
    // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
    export interface DefaultTheme extends Theme {}
}

// Context to track if AppThemeProvider is in the tree
export const AppThemeContext = React.createContext<boolean>(false);

export const AppThemeProvider: React.FC<{ children: React.ReactNode }> = ({
    children,
}) => {
    const appTheme = ORDERLY_THEME;
    const dsTheme = orderly;

    return (
        <AppThemeContext.Provider value={true}>
            <DSThemeProvider theme={dsTheme}>
                <StyledThemeProvider theme={appTheme}>
                    {children}
                </StyledThemeProvider>
            </DSThemeProvider>
        </AppThemeContext.Provider>
    );
};
